import { PersonaGetUsuarioLoggedDtoProps } from "api/DTOs/PersonaGetUsuarioLoggedDto"
import { updatePersonaById } from "api/Persona.service"
import { useGetUsuarioByCurrentUser } from "api/Usuario.hook"
import { STATUSCORRECT } from "common/components/ModalVerDocumento/constants"
import notification from "common/utils/notification"
import { useTranslation } from "react-i18next"
import ProfileData from "../../forms/ProfileData"

import "./profile.scss"

const Profile = () => {
  const { t } = useTranslation()
  const { usuario } = useGetUsuarioByCurrentUser()

  const handleUpdateProfile = async ({
    nombre,
    apellidos,
  }: PersonaGetUsuarioLoggedDtoProps) => {
    if (usuario?.persona?.id) {
      const response = await updatePersonaById({
        id: usuario.persona.id,
        nombre,
        apellidos,
      })
      response.status === STATUSCORRECT &&
        notification.success({
          body: `${t("notification.dataUpdaate")}`,
        })
    }
  }

  return (
    <div className='justify-center w-full p-4 d-flex'>
      <div className='mt-3 col-md-12 col-lg-12 col-xl-9'>
        <div className='justify-start w-full mt-3 d-flex'>
          <span className='text-lg text-gedesco'>{t("profile.title")}</span>
        </div>

        <div className='w-full p-4 mt-3 box'>
          <ProfileData
            t={t}
            usuario={usuario}
            updateProfile={handleUpdateProfile}
          />
        </div>
      </div>
    </div>
  )
}

export default Profile
